import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Upload, FileText } from "lucide-react";

export default function Documents() {
  const [rows, setRows] = useState([]);
  const load = async () => { const { data } = await api.get("/documents"); setRows(data); };
  useEffect(() => { load(); }, []);

  const upload = async (file) => {
    const fd = new FormData();
    fd.append("file", file); fd.append("category", "general");
    try { await api.post("/documents/upload", fd); toast.success("Uploaded"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Upload failed"); }
  };

  return (
    <div className="space-y-4" data-testid="documents-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500">Evidence</div>
          <h1 className="font-heading text-3xl font-bold text-slate-900">Documents</h1>
          <p className="text-sm text-slate-600 mt-1">Photos, PDFs, certificates, invoices, reports. Superseded records are retained.</p>
        </div>
        <label>
          <input type="file" className="hidden" onChange={(e)=>e.target.files?.[0] && upload(e.target.files[0])} data-testid="doc-upload-input"/>
          <span className="inline-flex items-center h-9 px-4 rounded-md bg-slate-900 text-white text-sm cursor-pointer hover:bg-slate-800"><Upload className="w-4 h-4 mr-1"/>Upload document</span>
        </label>
      </div>

      <Card className="border-slate-200"><CardContent className="p-4">
        {rows.length===0 ? <div className="text-sm text-slate-500 py-4">No documents yet.</div> : (
          <ul className="divide-y divide-slate-100">
            {rows.map((d)=>(
              <li key={d.id} className="py-3 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <FileText className="w-5 h-5 text-slate-400"/>
                  <div>
                    <div className="text-sm font-medium text-slate-900">{d.original_filename}</div>
                    <div className="text-xs text-slate-500">{d.category||"general"} · {(d.size/1024).toFixed(1)} KB · {new Date(d.uploaded_at).toLocaleString()}</div>
                    {d.related_type && <div className="text-xs text-slate-500">linked to {d.related_type}: {d.related_id}</div>}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  {d.is_superseded && <Badge className="bg-slate-100 text-slate-600 border-0">Superseded</Badge>}
                  <Button size="sm" variant="outline" asChild>
                    <a href={`${process.env.REACT_APP_BACKEND_URL}/api/documents/${d.id}/download`} target="_blank" rel="noreferrer">Open</a>
                  </Button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </CardContent></Card>
    </div>
  );
}
